import { createActionGroup, props } from '@ngrx/store'
import { InitialConfigState } from '../reducers/initial-config.reducer'

export const InitialConfigActions = createActionGroup({
  source: 'InitialConfig',
  events: {
    initialConfigLoaded: props<{ initialConfig: InitialConfigState }>(),
    initialConfigError: props,
  },
})
